import 'vant/lib/radio/index.less'
import 'vant/lib/radio-group/index.less'
// 依赖
import '../preview-text/style'
